import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Inserts ledger details after validation.
 * POST api/Onboarding/insert-ledger-details
 *
 * @param {Array<{ entityId, companyName, ledgerName }>} ledgerInsertRequests
 * @param {string} createdBy
 */
export const insertLedgerDetailsAction = async (
  ledgerInsertRequests,
  createdBy = "",
) => {
  try {
    const response = await apiClient.post(ATP_API_URL.INSERT_LEDGER_DETAILS, {
      ledgerInsertRequests,
      createdBy,
    });

    if (response?.status === 200) {
      return {
        success: true,
        message: response.data?.message || "Ledger details saved successfully",
        data: response.data,
      };
    }
    return { success: false, message: "Failed to insert ledger details" };
  } catch (error) {
    console.error("[InsertLedgerDetails] error:", error);
    return {
      success: false,
      message: error.message || "Failed to insert ledger details",
    };
  }
};
